import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function filtersTypifications(id) {
  const url = `/contacts/clients/${id}/managements/filters/`;
  const response = await httpManager.get(url);

  return response.data;
}
